import React from 'react';
import { Label } from '@mentimeter/slides-presentation-ui/title/label';
import { Box } from '@mentimeter/ragnar-ui/box';
import { MarkdownText } from '@mentimeter/slides-presentation-ui/text/markdown-text';
import type { BigStaticContent } from '@core-api/presentation/types/response';
import {
  usePresentationContext,
  usePresentationSlideContext,
} from '../../legacy-context/presentationContext';
import { getNinePointLayoutProperties } from '../../shared/utils/getNinePointLayoutProperties';
import { StaggerCss } from '../../shared/components/StaggerCss';
import { getLegacyLayout } from '../../utils/legacyContentSlideUtils/getLegacyLayout';
import { BigText } from './big-text/BigText';

export function BigPresentation() {
  const { useConfig } = usePresentationContext();

  const slide = usePresentationSlideContext();
  const staticContent = slide.staticContent as BigStaticContent;
  const title = slide.title || staticContent.message;
  const { enableAnimations } = useConfig();

  const legacyLayout = getLegacyLayout(slide) ?? {
    type: 'default',
    font_size_offset: 0,
    alignment_x: 1,
    alignment_y: 1,
    size: '25%',
  };

  const { textAlign, justifyContent, alignItems } =
    getNinePointLayoutProperties(legacyLayout);

  return (
    <Box
      width="100%"
      height="90%"
      data-testid="big-container"
      alignItems={alignItems}
      justifyContent="center"
    >
      <StaggerCss index={1} enableAnimations={enableAnimations}>
        {staticContent.label && (
          <Label>
            <MarkdownText
              disableLineBreaks
              source={staticContent.label}
              allowHyperlinks
            />
          </Label>
        )}

        <BigText
          key={slide.slideAdminKey}
          text={title}
          textAlign={textAlign}
          justifyContent={justifyContent}
        >
          <MarkdownText
            source={title}
            disableLineBreaks={false}
            allowBlankLines
            allowHyperlinks
          />
        </BigText>
      </StaggerCss>
    </Box>
  );
}
